export default {
  empty: '選択された商品はありません',
};
